<template>
    <DModal
        :show="showModal"
        :title="__('customers.contracts.restart_domain_transfer')"
        is-confirm
        @update:show="$emit('update:showModal', $event)"
        @confirm="restartTransfer"
        @close="$emit('close-modal')"
    >
        <div style="padding: 20px;">
            <DRow style="margin-top: 16px;">
                <DCol>
                    <DFormRow
                        :label="'Authcode'"
                    >
                        <DInput
                            id="new_auth_code"
                            v-model="newAuthCode"
                            type="text"
                        />
                    </DFormRow>
                </DCol>
            </DRow>
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'RestartDomainTransferModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        authCode: {
            type: String,
            default: null
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            newAuthCode: this.authCode
        }
    },
    methods: {
        restartTransfer () {
            this.$inertia.post(this.$route('customers.customers.contracts.restart-domain-transfer', {
                contract: this.contract.id,
                authCode: this.newAuthCode,
                customer: this.contract.customer_id
            }),
            {},
            {
                onSuccess: () => {
                    this.$emit('close-modal')
                }
            })
        }
    }
}
</script>
